import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {LocalStorageService} from '../../../core/services';

import {TableActionEvent, TableColumn, TableParams, TableRow, TableValue, TableValueSource} from '../../models';
import {SelectionModel} from '@angular/cdk/collections';
import Moment from 'moment';

export const TABLE_PAGESIZE = 'TABLE_PAGESIZE';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {
  @ViewChild(MatTable, {static: true}) table: MatTable<TableValue>;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  selection = new SelectionModel<TableRow>(true, []);

  // aux
  columns: TableColumn[] = [];
  displayedColumns: string[] = [];
  dataSource: MatTableDataSource<TableRow> = new MatTableDataSource([]);
  filter = true;
  pagination = true;
  pageEvent: PageEvent;
  pageSize = 5;
  totalCount = null;
  // output
  @Output() actioned = new EventEmitter<TableActionEvent>();
  @Output() paginationChange = new EventEmitter<PageEvent>();

  constructor(protected localStorageService: LocalStorageService) {
  }

  // input
  private _params: TableParams = null;
  get params(): TableParams {
    return this._params;
  }
  @Input()
  set params(params: TableParams) {
    this._params = params;
    this.update();
  }

  // search outside
  private _filterText: string = null;
  get filterText(): string {
    return this._filterText;
  }
  @Input()
  set filterText(search: string) {
    this._filterText = search;
    if(this._filterText)
      this.dataSource.filter = this._filterText.trim().toLowerCase();
    else{
      this.dataSource.filter = '';
    }
  }

  ngOnInit(): void {
    if(!this.params.ajaxPagination)
      this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if(this.params.sortTypes && this.params.sortTypes.length > 0){
      this.sort.active = this.params.sortTypes[0].key;
      this.sort.direction = 'desc';
    }

    this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
      let resp = data[sortHeaderId];

      if(this.params.sortTypes && this.params.sortTypes.length > 0){
        let sortType = this.params.sortTypes.find(sf => sf.key === sortHeaderId);
        if(sortType){
          switch (sortType.type) {
            case 'number':
              resp = parseInt(resp);
              break;
            case 'float':
              resp = parseFloat(resp);
              break;
          }
        }
      }

      let asd = typeof resp === 'string';

      if (typeof resp === 'string') {
        const expDate = /[0-9]{1,2} de [a-z]{3}\. de [0-9]{4}/i;
        if(resp.match(expDate)){
          Moment.locale('es');
          const d = Moment(resp, 'll');
          resp = d.format('YYYY/MM/DD');
        }
        else{
          resp = resp.toLocaleLowerCase();
        }
      }

      return resp;
    };
  }

  update() {
    this.columns = this.params.columns;
    this.displayedColumns = this.params.columns
      .filter(c => c.name !== '__source__')
      .map(c => c.name);
    this.dataSource.data = this.params.values;
    this.filter = this.params.filter || false;
    this.pagination = this.params.pagination || false;
    this.selection = new SelectionModel<TableRow>(true, []);

    let pageSize = parseInt(this.localStorageService.getItem(TABLE_PAGESIZE));
    if(!pageSize){
        pageSize = 5;
        this.localStorageService.setItem(TABLE_PAGESIZE, 5);
    }
    this.pageSize = pageSize;

    if(this.params.ajaxPagination){
      this.totalCount = this.params.ajaxPagination.length;
      if(this.params.ajaxPagination.reset)
        this.paginator.firstPage();
    }
  }

  actionClick(obj: TableValueSource, value: string) {
    this.actioned.emit({obj, value});
  }

  selectionChange(obj: TableValueSource, value: string) {
    this.selection.toggle(obj);
    this.actioned.emit({obj: this.selection.selected, value});
  }

  pageSelected(event: PageEvent){
      this.localStorageService.setItem(TABLE_PAGESIZE, event.pageSize);
      this.paginationChange.emit(event);
      return event;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
